import { SfTime } from '@app/adapters/time'

export enum CommunicationDateFormats {
  SHORT,
  LONG,
}

export default function communicationDate(
  input: moment.MomentInput,
  format: CommunicationDateFormats = CommunicationDateFormats.LONG
): string {
  const inputMoment = SfTime(input)
  const diffAsDays = SfTime().diff(inputMoment, 'days')

  if (diffAsDays === 0) {
    // Less than 1 day ago
    switch (format) {
      case CommunicationDateFormats.LONG:
        return inputMoment.fromNow()
      case CommunicationDateFormats.SHORT:
        return inputMoment.format('h:mm A')
    }
  } else if (diffAsDays < 7) {
    // Between 1 and 7 days ago
    switch (format) {
      case CommunicationDateFormats.LONG:
        return inputMoment.format('dddd h:mm A')
      case CommunicationDateFormats.SHORT:
        return inputMoment.format('D MMM YYYY')
    }
  } else {
    switch (format) {
      case CommunicationDateFormats.LONG:
        return inputMoment.format('MMMM D, YYYY h:mm A')
      case CommunicationDateFormats.SHORT:
        return inputMoment.format('D MMM YYYY')
    }
  }
}
